import React from "react";
import fruitsImg from "../assets/fruitsandveg.png"; // your image
import "./FruitsPages.css";

export default function FruitsPage() {
  return (
    <div className="fruits-container">

      {/* Top Image */}
      <div className="fruits-top-image">
        <img src={fruitsImg} alt="Fruits & Vegetables" />
      </div>

      {/* Title */}
      <h1>Fruits & Vegetables</h1>

      {/* Description */}
      <p>
        Our fruits and vegetables section offers the freshest and highest quality produce sourced
        from trusted farms. From juicy seasonal fruits to crisp and nutritious vegetables, we bring
        you a wide variety to support a healthy lifestyle.
        
        Whether you’re preparing daily meals or exploring new recipes, our selection ensures
        freshness, taste, and quality in every bite. We carefully handle and store our produce
        to maintain natural flavors and nutrients, giving you the best for your family.
      </p>

    </div>
  );
}